import ActionPorxy from './proxy'

/**
 * 获取当前APP平台
 */
export function getApp() {
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.communityInvokeApp) {
    // IOS 可调用
    return 'ios'
  } else if (window.communityInvokeApp) {
    // Android 可调用
    return 'android'
  }
  return false
}

export class PostMessage {
  isTest = false
  constructor(opt) {
    if (opt) {
      if (opt.test) {
        this._setTest()
      }
    }
  }

  _register = ActionPorxy.register

  /**
   * 向 APP 发送信息
   * @param {*} action 发送的事件名
   * @param {*} data 发送的数据
   * @param {*} rule 发送规则，满足规则才进行发送，规则包含：version(版本)、app(APP类型[ios|android])
   * @returns
   */
  async _communityInvokeApp(postData) {
    const { action, data } = postData
    // 如果配置了rules，则进行规则校验
    if (!this[action]) console.error(`[webview_invoke_app][Action: ${action}] Action not defind`)
    const canUse = this[action]?.canUse.bind(this)(data)
    if (canUse === false) {
      const msg = `[webview_invoke_app][Action: ${action}] Rule check failed`
      if (!this.isTest) console.error(msg)
      console.error(msg)
      console.error(`[webview_invoke_app][Action: ${action}] Test模式下继续执行`)
    }
    console.debug('[PostMessage]', postData)
    const app = getApp()
    if (app === 'ios') return await this._postMessageIOS({ action, data })
    if (app === 'android') return await this._postMessageAndroid({ action, data })
    console.debug('[webview_invoke_app] PostMessage Fail', { action })
  }

  // IOS 通用调用功能
  // IOS在做事件回调，返回的Promise
  _postMessageIOS({ action, data }) {
    return new Promise((resolve, reject) => {
      try {
        const ret = window.webkit.messageHandlers.communityInvokeApp.postMessage(JSON.stringify({ action, data }))
        console.debug('PostMessage Callback', ret)
        if (ret && ret.constructor === Promise) {
          ret
            .then((res) => {
              console.debug('PostMessage Callback Success:', res)
              if (action === 'getPrefetchData') {
                resolve(JSON.parse(res))
              } else {
                resolve(true)
              }
            })
            .catch((err) => {
              console.log(action, "action")
              console.debug('PostMessage Callback Error')
              console.error(err)
              reject(new Error('[webview_invoke_app] PostMessage Callback Error'))
            })
        } else {
          resolve(true)
        }
      } catch {
        reject(new Error('[webview_invoke_app] PostMessage Callback Error'))
      }
    })
  }

  // Android 通用调用功能
  _postMessageAndroid({ action, data }) {
    return new Promise((resolve, reject) => {
      try {
        window.communityInvokeApp.postMessage(JSON.stringify({ action, data }))
        resolve(true)
      } catch {
        reject(new Error('[webview_invoke_app] PostMessage Callback Error'))
      }
    })
  }

  // 设置为测试模式，调用接口数据打印到控制台
  _setTest() {
    this.isTest = true
    window.communityInvokeApp = {
      postMessage: (data) => {
        console.debug('[Test PostMessage]', data)
      },
    }
    window.communityContributeWeb = {
      postShareTag: (data) => {
        console.debug('[Test PostShareTag]', data)
      },
    }
  }
}
